import React, { FC } from 'react';
import { styled } from '../../styles';
import { BpDesignSystem } from '../../types';
import { Box } from '../Box/Box';

export type PopoverContentProps = BpDesignSystem.PropsWithChildren<{}>;

export const PopoverContent: FC<PopoverContentProps> = ({ dataTest, ...props }) => (
  <StyledPopoverContent data-test={dataTest} {...props} />
);

export const StyledPopoverContent = styled(Box)`
  padding: ${({ theme }) => theme.spacingSize.m} ${({ theme }) => theme.spacingSize.l}
`;
